import type { Theme } from '@material-ui/core/styles'

export const emailStyles = (theme: Theme) => ({
  emailContent: {
    color: theme.palette.text.secondary,
    textAlign: 'left' as const,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(0.5, 0),
    '& a': {
      textDecoration: 'underline'
    },
    '& p': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    '& ul, & ol': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(3)
    }
  },
  emailParagraphs: {
    '& p': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  }
})
